import s from "./Account.module.css";
import BuyButton from "../../assets/Components/StyledComponents/BuyButton";
import {NavLink} from "react-router-dom";
import {useSelector} from "react-redux";


const AccountOrders = () => {
    const userInfo = useSelector(state => state.setUserData);
    const ordersHistory = useSelector(state => state.setHistory);
    const ordersHistoryArray = useSelector(state => state.setHistory.orders);


    return (
        <div>
            <h3>Ваши заказы</h3>
            <div className={s.ordersItem}>
                <div className={s.ordersTitles}>
                    <h5>Детали заказа</h5>
                </div>
                <div className={s.ordersInfo}>
                    <ul>
                        <li>Адресс
                            доставки: <span>{`${userInfo.country}, ${userInfo.region}, ${userInfo.city}, ${userInfo.address}`}</span>
                        </li>
                        <li>Способо доставки: <span>{ordersHistory.delivery}</span></li>
                        <li>Способо оплаты <span>{ordersHistory.payment}</span></li>
                    </ul>
                </div>
            </div>
            <div className={s.ordersItem}>
                <div className={s.ordersTitles}>
                    <h5>Состав заказа</h5>
                </div>
                <div className={s.ordersInfoMain}>
                    {ordersHistoryArray[0].map((el, index) => {
                        const list = [];
                        for (let key in el) {
                            list.push(<ul>
                                <li>Название товара: {el[key].name}</li>
                                <li>Количество: {el[key].count}</li>
                                <li>Цена: {el[key].price} грн</li>
                            </ul>)
                        }
                        return <div key={index}>{list}</div>;
                    })}
                </div>
            </div>
        </div>
    )
}

export default AccountOrders;